import { request } from "../http";

export default {
  // 获取计价列表
  getCalculatorList(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/getCalculatorList",
      params,
      "json"
    );
  },

  // 添加面（通过产品）
  addCalculatorSideByProduct(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/addCalculatorSideByProduct",
      params,
      "json",{useParams:true}
    );
  },

  // 添加面（通过方案）
  addCalculatorSideByTemplatePlan(params) {
    return request(
      "post",
      "/sd_smi/api/v1/App_Calculator/addCalculatorSideByTemplatePlan",
      params,
      "json"
    );
  },

  // 复制面
  copyCalculatorSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/copyCalculatorSide",
      params,
      "json"
    );
  },

  // 删除面
  delCalculatorSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/delCalculatorSide",
      params,
      "json",
      {useParams: true}
    );
  },

  // 删除所有面
  delCalculatorAllSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/delCalculatorAllSide",
      params,
      "json"
    );
  },

  // 修改面
  editCalculatorSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/editCalculatorSide",
      params,
      "json"
    );
  },

  // 修改面产品信息
  editCalculatorSideProduct(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/editCalculatorSideProduct",
      params,
      "json"
    );
  },

  // 获取最近删除计价列表
  getDelCalculatorList(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/getDelCalculatorList",
      params,
      "json"
    );
  },

  // 恢复删除计价
  restoreDelCalculatorSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/restoreDelCalculatorSide",
      params,
      "json"
    );
  },

  // 添加到购物清单
  addToShoppinglist(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/addToShoppinglist",
      params,
      "json"
    );
  },

  // 获取购物清单
  getShoppinglist(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/getShoppinglist",
      params,
      "json"
    );
  },

  // 删除购物清单信息
  delShoppinglist(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/delShoppinglist",
      params,
      "json"
    );
  },

  // 彻底删除面
  delMustCalculatorSide(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/delMustCalculatorSide",
      params,
      "json"
    );
  },

  // 添加面（通过待购清单）
  addCalculatorSideByShoppingList(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Calculator/addCalculatorSideByShoppingList",
      params,
      "json"
    );
  },

  // 获取样板间空间类型列表
  getTemplateSpaceList(params) {
    return request(
      "post",
      "/sd_smi/api/v1/H5_Template/getTemplateSpaceList",
      params,
      "json"
    );
  }
};



// WEBPACK FOOTER //
// ./src/request/apis/calculator.js